<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M2.70968 5.00049L6.66129 1.6351C7.1129 1.25049 7.1129 0.673565 6.66129 0.28895C6.20968 -0.0956656 5.53226 -0.0956656 5.08065 0.28895L0.33871 4.32741C-0.112903 4.71203 -0.112903 5.28895 0.33871 5.67356L5.08065 9.71203C5.30645 9.90433 5.53226 10.0005 5.87097 10.0005C6.20968 10.0005 6.43548 9.90433 6.66129 9.71203C7.1129 9.32741 7.1129 8.75049 6.66129 8.36587L2.70968 5.00049Z"
		fill="white"
	/>
</svg>
